<template>
    <svg aria-hidden="true" width="25" height="14" viewBox="0 0 25 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.99594 0.75C7.18839 0.416666 7.66951 0.416667 7.86196 0.75L14.7902 12.75C14.9826 13.0833 14.7421 13.5 14.3572 13.5H0.500745C0.115844 13.5 -0.124717 13.0833 0.0677335 12.75L6.99594 0.75Z"
            fill="#E84C8D" />
        <path
            d="M17.862 13.25C17.6695 13.5833 17.1884 13.5833 16.9959 13.25L10.0677 1.25C9.87528 0.916667 10.1158 0.500001 10.5007 0.500001L24.3572 0.500002C24.7421 0.500002 24.9826 0.916669 24.7902 1.25L17.862 13.25Z"
            fill="#F6A6C5" />
    </svg>
</template>
